import { Typography } from "@mui/material";

export default function NotFound() {
  return (
    <Typography variant="h5" align="center" pt={5}>
      صفحه مورد نظر شما یافت نشد!
    </Typography>
  );
}
